const indexItems = [
  { title: '咒术回战', genre: '热血战斗', status: '已完结' },
  { title: '鬼灭之刃', genre: '热血战斗', status: '已完结' },
  { title: '间谍过家家', genre: '搞笑日常', status: '连载中' },
  { title: '堀与宫村', genre: '甜宠恋爱', status: '已完结' },
  { title: '关于我转生变成史莱姆这档事', genre: '异世界转生', status: '连载中' },
  { title: '一人之下', genre: '古风仙侠', status: '连载中' },
  { title: '死亡笔记', genre: '悬疑推理', status: '已完结' },
  { title: '进击的巨人', genre: '热血战斗', status: '已完结' },
  { title: 'Re:从零开始的异世界生活', genre: '异世界转生', status: '连载中' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            漫画索引
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            全站热门漫画快速索引，点击即达你想看的作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center group-hover:bg-primary-50 transition-colors duration-200">
                <i className="ri-book-open-line text-foreground-400 group-hover:text-primary-500 transition-colors duration-200"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <span
                    className={`text-xs px-1.5 py-0.5 rounded whitespace-nowrap ${
                      item.status === '连载中'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}
                  >
                    {item.status}
                  </span>
                </div>
                <p className="text-xs text-foreground-400 mt-0.5">{item.genre}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-400 transition-colors duration-200"></i>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border-2 border-foreground-200 text-foreground-600 text-sm font-medium hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多漫画 <i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}